// extracted by mini-css-extract-plugin
export default {"wrapper":"Loading_wrapper__k+OFP","loading":"Loading_loading__wJVoS","animateC":"Loading_animateC__lR5Li","animate":"Loading_animate__kz-8j"};